import { render, staticRenderFns } from "./DashboardCrud.vue?vue&type=template&id=48da6731"
import script from "./DashboardCrud.vue?vue&type=script&lang=js"
export * from "./DashboardCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports